import React, { useContext, useEffect, useState } from 'react';

import { PasswordInput as PasswordInputComponent } from '../../../../components/ui/Inputs/PasswordInput';
import { useContent } from '../../../../hooks/useContent';
import { useEvent } from '../../../../utils/analytics/useEvent';
import { MlifeAccountSetupContext } from '../MlifeAccountSetupContext';

export function PasswordInput() {
  const trackEvent = useEvent();
  const { password, isLoading, bindPassword, invalidFields, passwordValidations, isValidPassword } =
    useContext(MlifeAccountSetupContext);
  const { getContentByPath } = useContent();
  const [pwError, setPWError] = useState('');

  useEffect(() => {
    if (invalidFields.includes('password')) {
      const message = getContentByPath('shared.fields.password.empty') as string;
      if (pwError !== message) {
        trackEvent(
          'identity – mlife - account setup input error',
          'mlife registration input error',
          'mlifeaccountsetupinputerror',
          {
            errorField: getContentByPath('shared.fields.password.title'),
            errorDisplayed: message,
          },
        );
        setPWError(message);
      }
    } else if (password && !isValidPassword) {
      const message = getContentByPath('shared.fields.password.policy') as string;
      if (pwError !== message) {
        trackEvent(
          'identity – mlife - account setup input error',
          'mlife account setup input error',
          'mlifeaccountsetupinputerror',
          {
            errorField: getContentByPath('shared.fields.password.title'),
            errorDisplayed: message,
          },
        );
        setPWError(message);
      }
    } else {
      setPWError('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getContentByPath, invalidFields, trackEvent]);

  return (
    <PasswordInputComponent
      label={getContentByPath('shared.fields.password.title')}
      id='password'
      testId='password-input'
      aria-label={getContentByPath('shared.fields.password.label')}
      className='identity__field'
      name='password'
      invalidFields={invalidFields}
      passwordValidations={passwordValidations}
      disabled={isLoading}
      {...bindPassword}
    />
  );
}

PasswordInput.displayName = 'PasswordInputField';
